import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { auth, db } from "../../firebase/firebase";
import { loginSuccess, setTeacherData } from "../../store";
import { TEACHER_STATUS } from "../../utils/teacherStatus";
import styles from "../../login/AuthForm.module.css";

const TeacherApprovalStatus = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uid = useSelector((state) => state.login.uid);
  const role = useSelector((state) => state.login.role);
  const rejected = role === "rejected_teacher";

  useEffect(() => {
    if (!uid) return undefined;

    const unsub = onSnapshot(doc(db, "teachers", uid), (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      if (data.status === TEACHER_STATUS.APPROVED) {
        dispatch(loginSuccess({ uid, role: "teacher" }));
        dispatch(setTeacherData(data));
      }
      if (data.status === TEACHER_STATUS.REJECTED && role !== "rejected_teacher") {
        dispatch(loginSuccess({ uid, role: "rejected_teacher" }));
      }
    });

    return () => unsub();
  }, [dispatch, role, uid]);

  const logout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className={styles.authPage}>
      <div className={styles.authCard}>
        <h2 className={styles.title}>
          {rejected
            ? t("TeacherApproval.rejectedTitle")
            : t("TeacherApproval.pendingTitle")}
        </h2>
        <p className={styles.footerText}>
          {rejected
            ? t("TeacherApproval.rejectedBody")
            : t("TeacherApproval.pendingBody")}
        </p>
        <button className={styles.button} type="button" onClick={logout}>
          {t("TeacherApproval.logout")}
        </button>
      </div>
    </div>
  );
};

export default TeacherApprovalStatus;
